/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2luZG9vci1tb2R1bGUvd29ybGRhcmNoZXJ5X2luZG9vci13b3JsZC1zZXJpZXMtYW1hdGV1ci1yYW5raW5nL3Nlcmllcy1hbWF0ZXVyLXJhbmtpbmctZmlsdGVycy9zZXJpZXMtYW1hdGV1ci1yYW5raW5nLWZpbHRlcnMuY29tcG9uZW50LmNzcyJ9 */"];
export { styles as styles };
